import { StatisticalAnalysisIncidentsDossierExternalInfo } from '@/modules/statistical-analysis-module/views/incidents-dossier/incidents-dossier.model'
import { Nullable } from '@/shared/types/app.types'

export interface StatisticAnalysisExternalViewIncidentsStatisticsState {
    externalInfo: Nullable<StatisticalAnalysisIncidentsDossierExternalInfo>
}
export const initialStatisticAnalysisExternalViewIncidentsStatisticsState =
    (): StatisticAnalysisExternalViewIncidentsStatisticsState => ({
        externalInfo: null
    })
